import React from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { editQuestionnaire } from 'Consts/Questionnaire';
import ShadowBox from 'Components/UI/ShadowBox';
import Content from '../UI/Content';
import Wills from '../UI/EstatePlanning/Wills';
import PowerOfAttorney from '../UI/EstatePlanning/PowerOfAttorney';
import AdvancedHealthcareDirectives from '../UI/EstatePlanning/AdvancedHealthcareDirectives';
import EstatePlanningNotes from '../UI/EstatePlanning/EstatePlanningNotes';
import BeneficiarySummary from '../UI/EstatePlanning/BeneficiarySummary';
import Trusts from '../UI/EstatePlanning/Trusts';
import '../UI/EstatePlanning/EstatePlanning.css';

const EstatePlanning = ({
  wills,
  generalPowerOfAttorney,
  advancedHealthcareDirectives,
  trusts,
  nonRetirementAccounts,
  personalRetirementAccounts,
  employerSponsoredPlans,
  definedPensionPlans,
  groupLifeInsuranceAccounts,
  lifeInsuranceAccounts,
  otherAdvisors,
  clients,
  isAgent,
}) => {
  const simpleHousehold = useSimpleHousehold();
  function getEditLink(page, section) {
    if (simpleHousehold.householdResource) {
      return editQuestionnaire(page, {
        section,
        isAgent,
        householdId: simpleHousehold.householdResource.id(),
      });
    }
    return null;
  }

  return (
    <Content>
      <ShadowBox>
        <table className="wills-etc">
          <tbody>
            <tr>
              <Wills wills={wills} editLink={getEditLink('estatePlanning', 'will')} />
              <PowerOfAttorney generalPowerOfAttorney={generalPowerOfAttorney} editLink={getEditLink('estatePlanning', 'generalPowerOfAttorney')} />
              <AdvancedHealthcareDirectives
                advancedHealthcareDirectives={advancedHealthcareDirectives}
                editLink={getEditLink('estatePlanning', 'advancedHealthCareDirective')}
              />
              <Trusts trusts={trusts} editLink={getEditLink('estatePlanning', 'trust')} />
            </tr>
          </tbody>
        </table>

        <EstatePlanningNotes
          notes={
            clients.length > 0 ? clients[0].attributes.estatePlanningNotes : ''
          }
        />
      </ShadowBox>
      <div className="beneficiary-etc">
        <BeneficiarySummary
          nonRetirementAccounts={nonRetirementAccounts}
          personalRetirementAccounts={personalRetirementAccounts}
          employerSponsoredPlans={employerSponsoredPlans}
          definedPensionPlans={definedPensionPlans}
          groupLifeInsuranceAccounts={groupLifeInsuranceAccounts}
          lifeInsuranceAccounts={lifeInsuranceAccounts}
          otherAdvisors={otherAdvisors}
          isAgent={isAgent}
        />
      </div>
    </Content>
  );
};

EstatePlanning.propTypes = {
  wills: PropTypes.array.isRequired,
  generalPowerOfAttorney: PropTypes.array.isRequired,
  advancedHealthcareDirectives: PropTypes.array.isRequired,
  trusts: PropTypes.array.isRequired,
  nonRetirementAccounts: PropTypes.array.isRequired,
  personalRetirementAccounts: PropTypes.array.isRequired,
  employerSponsoredPlans: PropTypes.array.isRequired,
  definedPensionPlans: PropTypes.array.isRequired,
  groupLifeInsuranceAccounts: PropTypes.array.isRequired,
  lifeInsuranceAccounts: PropTypes.array.isRequired,
  otherAdvisors: PropTypes.array.isRequired,
  clients: PropTypes.array.isRequired,
  isAgent: PropTypes.bool.isRequired,
};

export default EstatePlanning;
